import { writable } from "svelte/store";
import axios from "../config/axios";
import { questionnaireValidation } from "./validation";
import { getMattressType, mapToAdvice } from "./adviceMapping";
import type { Advice, AdviceApiResponse } from "../types/advice";
import { getNewMattressReason } from "../helpers/helpers";

const { subscribe, set } = writable(null);

function getPrimaryAdvice(data: AdviceApiResponse): Advice {
  const rawAdvice = Object.entries(data).reduce((result, [key, value]) => {
    if (key.endsWith("-partner")) return result;

    Object.assign(result, { [key]: value[0] });
    return result;
  }, {});

  return mapToAdvice(rawAdvice);
}

function getPartnerAdvice(data: AdviceApiResponse): Advice {
  const partialKeysToInclude = [
    "-partner",
    "budget-two-persons",
    "mattress-type",
  ];

  const rawAdvice = Object.entries(data).reduce((result, [key, value]) => {
    if (!partialKeysToInclude.some((partialKey) => key.endsWith(partialKey)))
      return result;

    Object.assign(result, { [key]: value[0] });

    return result;
  }, {});

  return mapToAdvice(rawAdvice);
}

function loadAdvice(results): void {
  axios
    .post("/results/process", results)
    .then((response) => {
      const advice = {
        "mattress-type": getMattressType(response.data),
        "new-mattress-reason": getNewMattressReason(
          response.data["new-mattress-reason"][0].value
        ),
        "advice-primary": getPrimaryAdvice(response.data),
        "advice-partner": null,
      };

      if (
        !!response.data["advice-partner"] &&
        response.data["advice-partner"][0].value === "yes"
      ) {
        advice["advice-partner"] = getPartnerAdvice(response.data);
      }

      set(advice);
    })
    .catch((error) => {
      set(error);
    });
}

function resetAdvice(): void {
  questionnaireValidation.deactivate();

  set(null);
}

export const advice = {
  subscribe,
  loadAdvice,
  resetAdvice,
};
